<template>
	<div class="d-flex align-items-center">
		<div class="flex-grow-1">
			<Button
				v-if="withBack"
				text="Zurück"
				secondary
				smaller
				@click="$emit('back')"
			/>
		</div>
		<div v-if="withContinue">
			<Button
				:text="continueText"
				class="mt-3"
				icon="checkmark"
				:disabled="continueDisabled"
				:loading="continueLoading"
				@click="$emit('continue')"
			/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button"

export default {

	components: {
		Button
	},

	props: {
		continueText: {
			type: String,
			required: false,
			default: 'Weiter',
		},
		continueDisabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		continueLoading: {
			type: Boolean,
			required: false,
			default: false,
		},
		withContinue: {
			type: Boolean,
			required: false,
			default: true,
		},
		withBack: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
}
</script>
